import { render, staticRenderFns } from "./quesInstru5.vue?vue&type=template&id=a96e0da6"
import script from "./quesInstru5.vue?vue&type=script&lang=js"
export * from "./quesInstru5.vue?vue&type=script&lang=js"
import style0 from "./quesInstru5.vue?vue&type=style&index=0&id=a96e0da6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports